module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_13_m2.9883389053c5c911eed1ddd829272915.png";